<template>
  <ul class="tutorials-category-list">
    <TutorialsListRow
      v-for="category in onboardingCategories"
      :key="category.id"
      :name="category.name"
      :secondary-text="category.subtitle"
      :trailing-text="`${category.topicIds.length} topics`"
      :data-cy="`tutorials-category-${category.id}`"
      @click="emit('select', category.id)"
    />
  </ul>
</template>

<script setup>
import { onboardingCategories } from '@/constants/onboardingChecklist';

const emit = defineEmits(['select']);
</script>

<style lang="scss" scoped>
.tutorials-category-list {
  @apply tw-m-0 tw-list-none tw-p-0;
}
</style>
